export const SG_REWARDS_TERMS_AND_CONDITIONS =
  'http://www.sweetgreen.com/sg-rewards-program-agreement';
